export const firebaseConfProduction = {
		projectId: 'bingo-dev-6c31e',
		appId: '1:429328969581:web:d497deacbf7e225bc47464',
		storageBucket: 'bingo-dev-6c31e.appspot.com',
		apiKey: 'AIzaSyA6fNJoOqYNziHaV-jiVB0HlGRW_0Lb9U4',
		authDomain: 'bingo-dev-6c31e.firebaseapp.com',
		messagingSenderId: '429328969581',
		measurementId: 'G-XW720XL285'
};
